import React, { useEffect, useState, useRef } from 'react';
import Callable from '../../shared/Callable';
import logoutService from '../../login/logoutService';
import AddressSection from '../../profile/components/common/AddressSection';
import Tick from '../../_styles/images/tick.svg';
import { isEqual, isNull } from 'lodash';
import { validatePhone } from '../../profile/helper';
import { formatPhoneNumber } from '../../shared/inputs/PhoneEntry';
import analyticsService from '../../shared/analytics/analytics-service';


export default function EmployerIdPopup(props) {
    const node = useRef();

    const [employeeId, updateEmployeeId] = useState("");
    const [employeeIdValid, updateEmployeeidValid] = useState(true);
    const [disableButton, updateDisableButton] = useState(false);
    const [phoneNumber, updatePhoneNumber] = useState({});
    const [phoneNumberValid, updatePhoneNumberValid] = useState(true);
    const [homeAddress, updateHomeAddress] = useState({});
    const [mailingAddress, updateMailingAddress] = useState({});
    const [homeAddressValid, updateHomeAddressValid] = useState(true);
    const [mailAddressValid, updateMailAddressValid] = useState(true);
    const [isChecked, updateIsChecked] = useState(false);
    const [showAddress, updateShowAddress] = useState(false);
    const [showPhone, updatePhoneShow] = useState(false);
    const [addedPhone, updateAddedPhone] = useState(false);
    const [addedAddress, updateAddedAddress] = useState(false);
    const [errorAnalyticsFired, setErrorAnalyticsFired] = useState(false);


    useEffect(() => {
        if (employeeId == "" || !employeeIdValid) {
            updateDisableButton(true);
        }
        analyticsService.analyticsProcessEvent({
            "event": "modal_view_generic",
            "context": {
                "event_action": "dashboard/mandatory eid modal"
            }
          });
    }, []);

    function hasAddressData(address) {
        return Object.values(address).every(
            v => v === "" || v == null
        );
    }

    function hasRequiredAddressFields(address) {
        const requiredFields = [
            "city",
            "latitude",
            "longitude",
            "state",
            "line1",
            "zip"
        ];

        return requiredFields.every(key => {
            const value = address?.[key];

            // latitude & longitude: allow numbers (including negative floats) or non-empty strings
            if (key === "latitude" || key === "longitude") {
                return (
                    value !== null &&
                    value !== undefined &&
                    value !== "" &&
                    !Number.isNaN(value)
                );
            }

            // other fields: must be non-empty strings
            return typeof value === "string" && value.trim() !== "";
        });
    }

    const isEmptyPhoneNumber = phone => !phone?.number || phone.number.trim().toUpperCase() === "N/A";

    useEffect(() => {
        if ((!hasRequiredAddressFields(homeAddress)) && (!hasRequiredAddressFields(props.profile.homeAddress) || props.profile.addresses && isNull(props.profile.addresses.homeAddress))) {
            updateShowAddress(true);
            updateAddedAddress(true);
            updateHomeAddressValid(false);
        }
        // Set checkbox to checked if mailing address is empty OR props mailing address is empty OR home address equals mailing address
        if ((!hasRequiredAddressFields(mailingAddress) && 
            !hasRequiredAddressFields(props.profile.mailingAddress)) ||
            (hasRequiredAddressFields(props.profile.homeAddress) && 
             (isEqual(props.profile.homeAddress, mailingAddress) || 
              isEqual(props.profile.homeAddress, props.profile.mailingAddress)))) {
            updateIsChecked(true);
        } else {
            updateIsChecked(false);
        }
        if (isEmptyPhoneNumber(props.profile.phone)) {
            updatePhoneShow(true);
            updateAddedPhone(true);
            // updatePhoneNumberValid(false);
        }
    }, [props.profile]);


    function validateEmployeeId(value) {
        if (!props.employeeInfo?.employeeIdPattern) {
            if (value && value.length > 0) {
                return true;
            } else {
                return false;
            }
        } else {
            const patternString = props.employeeInfo?.employeeIdPattern;
            const regex = new RegExp(patternString);
            if (regex.test(value)) {
                return true;
            } else {
                return false;
            }
        }
    }

    function onChangeEmployeeId(value) {
        updateEmployeeId(value);
        if (validateEmployeeId(value)) {
            updateEmployeeidValid(true);
            setErrorAnalyticsFired(false);
        } else {
            updateEmployeeidValid(false);
        }
    }

    function onChangePhone(value) {
        var val = formatPhoneNumber(value)
        updatePhoneNumber({
            "number": val,
            "type": "Mobile"
        });
        if (val.length < 12) {
            updatePhoneNumberValid(false);
        } else {
            updatePhoneNumberValid(true);
        }
    }

    function onHomeAddressChange(value, valid) {
        updateHomeAddress(value);
        updateHomeAddressValid(valid);
    }

    function onMailAddressChange(value, valid) {
        updateMailingAddress(value);
        updateMailAddressValid(valid);
    }

    function saveEmployerId() {
        var request = {
            employeeId,
            homeAddress: addedAddress ? homeAddress : null,
            mailingAddress: addedAddress ? (isChecked ? homeAddress : mailingAddress) : null,
            phone: addedPhone ? phoneNumber : null
        };
        props.saveEmployerId(request, addedAddress, addedPhone);
    }

    useEffect(() => {
        const isAddressValid = addedAddress ? isChecked ? (hasRequiredAddressFields(homeAddress) && homeAddressValid) : ((hasRequiredAddressFields(mailingAddress) && mailAddressValid) && (hasRequiredAddressFields(homeAddress) && homeAddressValid)) : true;
        const isEmployeeIdValid = validateEmployeeId(employeeId);
        const isPhoneValid = addedPhone ? phoneNumber.number && phoneNumber.number.length === 12 : true;
        if (isPhoneValid && isEmployeeIdValid && isAddressValid) {
            updateDisableButton(false);
        } else {
            updateDisableButton(true);
        }
    }, [homeAddressValid, mailAddressValid, phoneNumberValid, employeeIdValid, isChecked, homeAddress, mailingAddress, phoneNumber, employeeId])

    const updateIsCheckedValue = (e) => {
        var isCheckedValue = e.currentTarget.getAttribute('aria-checked') === 'true';
       updateIsChecked(!isChecked)
       if(isCheckedValue){
        updateMailingAddress({});
        updateMailAddressValid(false);
       }
      }

      useEffect(() => {
        if (employeeId && employeeId.length > 0 && !employeeIdValid && !errorAnalyticsFired) {
          analyticsService.analyticsProcessEvent({
            "event": "user_error",
            "context": {
              "event_action": "employee id doesn't match the required format"
            }
          });
          setErrorAnalyticsFired(true);
        } else if (!employeeIdValid && employeeId.length === 0 && errorAnalyticsFired) {
          analyticsService.analyticsProcessEvent({
            "event": "user_error",
            "context": {
              "event_action": "employee id is required"
            }
          });
          setErrorAnalyticsFired(false);
        }
    },[employeeIdValid, errorAnalyticsFired, employeeId]);

    return (
        <div className="employerid-popup show" aria-live='polite' role='alert' aria-modal='true' ref={node}>
            <div className='employer-id-popup'>
                <div className="employer-id-container">
                    <div className='top-header'>
                        <div className='heading'>
                            Required Information
                        </div>
                    </div>
                    <div className='content'>
                        <div className='employeeid-content'>
                            <div className='sub-heading'>* Required Field</div>
                            <div className='header'>Employee ID</div>
                            <div className='subtext'>Your employer requires that we collect your Employee ID.</div>
                            <div className='subtext1'>If you do not know your Employee ID, call your employer.</div>

                            <div className='employer-field'>
                                <fieldset className='field'>
                                    <div className='label'>
                                        <label htmlFor='employeeid'>Employee ID*</label><span className='id-description'>{`(${props.employeeInfo?.employeeIdPatternDescription ? props.employeeInfo?.employeeIdPatternDescription : "Enter at least one character"})`}</span>
                                    </div>
                                    <input id='employeeid' aria-describedby="employeeIdError" type='text' className={employeeIdValid ? 'employee-id-field' : 'employee-id-field error'} onChange={(e) => onChangeEmployeeId(e.target.value)} value={employeeId || ''} ></input>
                                    {employeeIdValid ? null
                                        :
                                        <div className="invalid-text" aria-live='assertive'>
                                            {employeeId && employeeId.length > 0 ? 'Employee ID doesn’t match the required format' : 'Employee ID is required'}
                                        </div>
                                    }
                                </fieldset>
                            </div>
                        </div>
                        {
                            showPhone &&
                            <div className='phone-container'>
                                <div className='header'>Phone Number</div>
                                <div className='subtext'>Please enter your phone number.</div>
                                <div className='phone-field'>
                                    <fieldset className='field number-field'>
                                        <div className='label'>
                                            <label htmlFor={'Phonenumber'}>Phone Number*</label>
                                        </div>
                                        <input id={'Phonenumber'} aria-describedby="phoneError" type='text' className={phoneNumberValid ? 'number-field' : 'number-field error'} onChange={(e) => onChangePhone(e.target.value)} value={phoneNumber.number || ''} placeholder='Phone Number'></input>
                                        {phoneNumberValid ? null
                                            :
                                            <div className="invalid-text" aria-live='assertive' id="phoneError">
                                                {'Please enter a valid phone number'}
                                            </div>
                                        }
                                        <div className='phone-disclaimer'>Standard text messaging rates apply.</div>
                                    </fieldset>
                                </div>
                            </div>
                        }

                        {
                            showAddress &&

                            <div className='address-container'>
                                <div className='header'>Home Address</div>
                                <div className='subtext'>Please enter your address.</div>
                                <AddressSection onChange={onHomeAddressChange} address={homeAddress} />
                                <div className='header mailing'>Mailing Address</div>
                                <div className='condition'>
                                    {isChecked ?
                                        <div className='checkbox selected' role='checkbox' aria-checked={isChecked} tabIndex={0} onClick={(e) => updateIsCheckedValue(e)} aria-label='mailing address is the same as home address'>
                                            <img src={Tick} alt='Checked' />
                                        </div>
                                        :
                                        <div role='checkbox' aria-checked={isChecked} className='checkbox' tabIndex={0} aria-label='Check this box if mailing address is the same as home address' onClick={(e) => updateIsCheckedValue(e)}></div>
                                    }
                                    <div className='text'>Same as Home Address</div>
                                </div>
                                {!isChecked && <AddressSection onChange={onMailAddressChange} address={mailingAddress} />}
                            </div>
                        }



                        <div className='footer'>
                            <div className='second-line'>If you have any questions, call <Callable className="greentext" phone="800 VAN-4-WORK"  analyticsEvent={true} defaultAnalytics={true} modal={true}  modalValue={"dashboard/mandatory eid modal"} /></div>
                        </div>
                        {
                            props.startEmployerLoader &&
                            <span aria-live='assertive' role='alert' id="employee-loader">
                                <div className="employer-loader" aria-busy='true'><span className='screenreader-only'>updating Employeeid</span></div>
                            </span>
                        }

                    </div>

                    <div className='button-container'>
                        <button tabIndex={0} className='logout-button' onClick={() =>
                            {
                            analyticsService.analyticsProcessEvent({
                                "event": "modal_click_generic",
                                "context": {
                                    "event_action": "logout",
                                    "event_detail": {
                                        "modal": "dashboard/mandatory eid modal"
                                    }
                                }
                            });
                            logoutService.logout()
                            }} >Log out</button>
                        <button tabIndex={0} disabled={(disableButton || props.startEmployerLoader)} className='continue-button' onClick={() => saveEmployerId()} >Submit</button>
                    </div>

                </div>
            </div>
        </div>
    );
}
